import {Header} from "../components/Header.js";
import {EmailInput} from "../components/input/EmailInput.js";
import {InputValidator} from "../util/input-validate/inputValidation.js";
import {checkDuplicateEmail} from "../../../apiCall/signup/index.js";
import {InputErrorHandler} from "../util/input-error-handler/index.js";
import {addEmail, getPlanId, isWebView} from "../store.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";

function draw() {
    $("body").append(getTemplate());
    new Header($('#morningmateBusinessEmailInputSection').find(".js-section-header"), {
        isShowLoginBtn : true,
        isShowPrevBtn : true
    });

    new EmailInput($('#morningmateBusinessEmailInputSection').find(".js-contents-main"), {
        isAfter : true,
        $posTarget : $("#subTxt"),
        isLast : true,
        addClass: "",
        submit : moveEmailAuthView,
    });

    $("#moveMorningMate").off("click").on("click", () => {
        moveEmailAuthView();
    })

}

function getTemplate() {
    const subText = Often.isGlobal() ? i18next.t(login.freetrialMorningmate) : i18next.t(login.freetrial30d)
    return `
        <section id="morningmateBusinessEmailInputSection" class="signup-wide-pop morningmate-type">
          <header class="js-section-header"></header>
          <article>
            <div class="pop-main js-contents-main">
              <h3>${getMainText()}</h3>
              <p id ="subTxt">${getSubText()}</p>
              <button id="moveMorningMate">${subText}</button>
            </div>
            <p class="bottom-text" style="text-align: center">
                 ${getPolicyBottomTemplate()}
            </p>
          </article>
        </section>
    `
}
function getSubText() {
    const Internationalization = Mutil.requireIIFE("Internationalization");
    if(!Internationalization.getCurrentLanguage().toLowerCase().includes("en")) {
        return `${i18next.t(login.starFreeTrialDesc)}`
    }
    const planId = getPlanId();
    if(planId.indexOf("BUSINESS") > -1) {
        return `No credit card needed.<br />You can continue or downgrade after.`;
    }

    if(planId.indexOf("PRO") > -1) {
        return `No credit card needed. <br /> You can continue, upgrade, or downgrade after.`;
    }

    return `No credit card needed. <br /> Upgrade anytime you want!`
}
function getMainText() {
    const Internationalization = Mutil.requireIIFE("Internationalization");
    if(!Internationalization.getCurrentLanguage().toLowerCase().includes("en")) {
        return `${i18next.t(login.useForFreeMorningmate)}`
    }
    const planId = getPlanId();
    if(planId.indexOf("BUSINESS") > -1) {
        return "Free 31-Day Business+ Trial";
    }

    if(planId.indexOf("PRO") > -1) {
        return "1 Month Free PROmo";
    }

    return "Free Forever"
}
function getPolicyBottomTemplate() {
    const policy = `<a href="/terms.act" target="${isWebView() ? "_self" : "_blank" }">${i18next.t(login.srvcetrms)}</a>, <a href="/privacy.act" target="${isWebView() ? "_self" : "_blank" }">${i18next.t(login.pvcyplcy)}</a>`;
    const Internationalization = Mutil.requireIIFE("Internationalization");
    if(Internationalization.getCurrentLanguage().toLowerCase().includes("en")) {
        return `By signing up, you agree to our ` + policy + ".<br />You also agree to receive product related emails."
    }

    if(Internationalization.getCurrentLanguage().toLowerCase() === 'ko' || Internationalization.getCurrentLanguage().toLowerCase()  === 'ja') {
        return policy + `${i18next.t(login.agreepvcy)}`;
    }
    return `${i18next.t(login.agreepvcy)}` + policy;
}
function isDuplicateEmail(errorCode) {
    return Mutil.n2v(errorCode) !== '0000';
}

async function moveEmailAuthView() {
    const $emailInput = $("#emailInput");
    if (!InputValidator.inputValidate($emailInput)) {
        return;
    }
    const email = $emailInput.val();
    const dat = await checkDuplicateEmail(email);
    if (isDuplicateEmail(dat['ERR_CD'])) {
        InputErrorHandler.activeErrorModeAboutInput($emailInput, i18next.t(common.occupy, {val: $t(dictionary.email)}));
        return;
    }
    addEmail(email);
    SignUpViewChanger.loadEmailAuthView();
}

export const MorningMateBusinessEmailInputView = {
    draw
}